var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public"},[_vm._m(0),_c('div',{staticClass:"public__content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"public__logo-container"},[_c('img',{attrs:{"src":require("@/assets/imgs/logo.svg")}})])
}]

export { render, staticRenderFns }